import config from 'config';

export const getMediaAssetURL = (mediaAssetID) =>
  mediaAssetID ? `${config.serverURL}/api/mediaassets/stream/${mediaAssetID}` : null;
